import { useState } from 'react';

const IMPORTER_OPTIONS = [
  'APERAK',
  'DELFOR',
  'DESADV',
  'INVRPT',
  'INVOIC',
  'JREPLA',
  'MEQPOS',
  'ORDERS',
  'PARTIN',
  'PCSTOCK',
  'PRODAT',
  'PURCHASE',
  'QUOTES',
  'SND0768',
  'SND0769',
  'SND0770',
  'SND0771',
] as const;

type Filters = {
  selectedImporter?: string;
};

export type ImportLogsFilters = ReturnType<typeof useImportLogsFilters>;

export const useImportLogsFilters = () => {
  const [filters, setFilters] = useState<Filters>({});

  const handleImporterChange = (val?: string) => {
    setFilters((prev) => ({ ...prev, selectedImporter: val }));
  };

  return {
    handlers: {
      handleImporterChange,
    },
    filters,
    options: {
      importerOptions: IMPORTER_OPTIONS,
    },
  };
};
